import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Closure templates", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrSelect = _resolveComponent("NrSelect")!
  const _component_NrFormLabel = _resolveComponent("NrFormLabel")!
  const _component_NrEditor = _resolveComponent("NrEditor")!
  const _component_NrFormSelect = _resolveComponent("NrFormSelect")!
  const _component_NrModal = _resolveComponent("NrModal")!

  return (_openBlock(), _createBlock(_component_NrModal, {
    "primary-button-text": "Close request",
    "secondary-button-text": "Cancel",
    title: "Close request",
    "has-secondary-button": true,
    show: !!$props.active,
    onOnCloseClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('on-close'))),
    onOnPrimaryClick: $options.submitForm,
    onOnSecondaryClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('on-close')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_NrSelect, {
        "append-to-body": "",
        placeholder: "Select a closure template",
        uid: "closure_templates",
        multiple: "",
        modelValue: $data.selectedClosureTemplates,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.selectedClosureTemplates) = $event)),
        options: $options.filteredClosureTemplates,
        loading: _ctx.dataFetchState.closure_templates.fetching,
        hasMore: !_ctx.dataFetchState.closure_templates.end,
        onInput: $options.setClosureTemplate,
        onLoadMore: $options.handleClosureTemplateScroll,
        onSearch: $options.filterClosureTemplates,
        onOpen: $options.filterClosureTemplates
      }, {
        label: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["modelValue", "options", "loading", "hasMore", "onInput", "onLoadMore", "onSearch", "onOpen"]),
      _createVNode(_component_NrFormLabel, null, {
        default: _withCtx(() => [
          _createTextVNode("Closure template editor")
        ]),
        _: 1
      }),
      _createVNode(_component_NrEditor, {
        bulletList: "",
        orderedList: "",
        link: "",
        autofocus: "",
        placeholder: "Type your message here or select a template above.",
        rows: 8,
        "data-id": "closure_text",
        modelValue: $data.closureText,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.closureText) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_NrFormSelect, {
        label: "Request visibility",
        modelValue: $data.selectedRequestVisibility,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.selectedRequestVisibility) = $event)),
        placeholder: 
        $data.selectedRequestVisibility && $data.selectedRequestVisibility.label
          ? $data.selectedRequestVisibility.label
          : ''
      ,
        options: $options.reqVisibilities
      }, null, 8, ["modelValue", "placeholder", "options"])
    ]),
    _: 1
  }, 8, ["show", "onOnPrimaryClick"]))
}